import { render, staticRenderFns } from "./dictamen-2026.vue?vue&type=template&id=4cb33212&scoped=true&"
import script from "./dictamen-2026.component.ts?vue&type=script&lang=ts&"
export * from "./dictamen-2026.component.ts?vue&type=script&lang=ts&"
import style0 from "./dictamen-2026.vue?vue&type=style&index=0&id=4cb33212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb33212",
  null
  
)

export default component.exports